import React, { useState } from 'react'
import { Button, Modal, SimpleReactValidator } from '../../config/react'
const UploadMedia = (props) => {
  const [validator, setValidator] = useState(new SimpleReactValidator())
  const [loading] = useState(false)
  const [CurrentImageVariant] = useState(
    props.props.CurrentImageVariant !== undefined ? props.props.CurrentImageVariant : []
  )
  const [images, setImages] = useState(
    props.props.ProductMedia !== undefined ? props.props.ProductMedia.images : []
  )
  const [videos, setVideos] = useState(
    props.props.ProductMedia !== undefined ? props.props.ProductMedia.video : []
  )
  const defaltMedia = props.props.SelectedMediaFiles
  const [SelectedMediaFiles, setSelectedMediaFiles] = useState(props.props.SelectedMediaFiles)
  const [SearchString, setSearchString] = useState('')
  const [IsShowOptionModal, setIsShowOptionModal] = useState(false)
  const [ImageApplyType, setImageApplyType] = useState('current-option')
  const [ImageOptionId, setImageOptionId] = useState('')
  const closeModal = () => {
    setSelectedMediaFiles(defaltMedia)
    props.closeMediaPopup(true)
    searchMedia()
  }
  const searchMedia = () => {
    setImages([])
    setVideos([])
  }
  const searchImage = (e) => {
    const search = e.target.value
    if (search.length >= 2) {
      setSearchString(search.toLowerCase())
    } else {
      setSearchString('')
    }
  }
  const handleInputChanges = (prop) => (event) => {
    const target = event.target
    const value = target.value
    if (prop === 'attribute_option') {
      setImageOptionId(value)
    } else if (prop === 'images') {
      if (target.checked) {
        // SelectedMediaFiles.images.push(value)
        setSelectedMediaFiles((prevState) => ({
          ...prevState,
          images: [...prevState.images, value] // Append the new value
        }))
      } else {
        // SelectedMediaFiles.images = SelectedMediaFiles.images.filter((e) => e !== value)
        setSelectedMediaFiles((prevState) => ({
          ...prevState,
          images: prevState.images.filter((e) => e !== value) // Remove the specific value
        }))
      }
    } else {
      if (target.checked) {
        setSelectedMediaFiles({ ...SelectedMediaFiles, [prop]: event.target.value })
      } else {
        setSelectedMediaFiles({ ...SelectedMediaFiles, [prop]: '' })
      }
    }
  }
  const submitMedia = (e) => {
    if (props.props.index !== '') {
      setIsShowOptionModal(true)
    } else {
      props.onSubmitMedia(SelectedMediaFiles, '')
    }
  }
  const setMainImage = (e, baseImage) => {
    const mainImageKey = 'base_image'
    setSelectedMediaFiles({ ...SelectedMediaFiles, [mainImageKey]: baseImage })
  }
  const onCheckAll = (e) => {
    if (e.target.checked) {
      if (SearchString === '') {
        setSelectedMediaFiles({
          ...SelectedMediaFiles,
          images: [...props.props.ProductMedia.images]
        })
      } else {
        setSelectedMediaFiles({
          ...SelectedMediaFiles,
          images: props.props.ProductMedia.images.filter(
            (item) => item.toLowerCase().indexOf(SearchString) > -1
          )
        })
      }
    } else {
      setSelectedMediaFiles({
        ...SelectedMediaFiles,
        images: []
      })
    }
  }
  const onApplyTypeChange = (e) => {
    if (e.target.value === 'current-option') {
      setValidator(new SimpleReactValidator())
    }
    setImageApplyType(e.target.value)
  }
  const applyImages = (e) => {
    if (!validator.allValid()) {
      validator.showMessages()
      return
    } else {
      validator.hideMessages()
    }
    props.onSubmitMedia(SelectedMediaFiles, ImageOptionId)
  }
  return (
    <>
      <Modal
        id="product-media-modal"
        size="lg"
        show={props.props.IsShowImagesVideoModal}
        onHide={closeModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        scrollable={true}
      >
        <Modal.Header>
          <div>
            <h6>Select Media</h6>
          </div>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={(e) => closeModal(e)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-x"
            >
              <line
                x1="18"
                y1="6"
                x2="6"
                y2="18"
              ></line>
              <line
                x1="6"
                y1="6"
                x2="18"
                y2="18"
              ></line>
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <input
                  type="text"
                  name="search"
                  className="form-control"
                  placeholder="Search..."
                  onChange={(e) => searchImage(e)}
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                <h4>Images</h4>
                <hr />
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    id="chkSelectAllImage"
                    name="images"
                    onChange={(e) => onCheckAll(e)}
                  />
                  <label
                    htmlFor="chkSelectAllImage"
                    className="fs-14 mb-0 ml-1"
                  >
                    Select All
                  </label>
                </div>
              </div>
            </div>
            <div className="row mt-3 upload-media-row">
              {images.length > 0 ? (
                images.map((image, imageIndex) => {
                  if (
                    SearchString !== '' &&
                    image.split('/').pop().toLowerCase().indexOf(SearchString) < 0
                  )
                    return null
                  const fileName = new URL(image).pathname.split('/').pop()
                  return (
                    <div
                      className="col-md-4 col-lg-3 col-xl-2 upload-media-col"
                      key={`image-${image}`}
                    >
                      <div className="upload-media-repeat">
                        <input
                          type="checkbox"
                          className="upload-media-checkbox"
                          id={'image_' + imageIndex}
                          name="images"
                          onChange={handleInputChanges('images')}
                          value={image}
                          checked={SelectedMediaFiles.images.includes(image)}
                        />
                        <label htmlFor={'image_' + imageIndex}>
                          <div className="col-12">
                            <img
                              src={image}
                              width={150}
                              height={150}
                            />
                          </div>
                          <p>{fileName}</p>
                          {SelectedMediaFiles.base_image === image ? (
                            <span>Main Image</span>
                          ) : (
                            <button
                              type="button"
                              className="btn"
                              onClick={(e) => setMainImage(e, image)}
                            >
                              Set as Main Image
                            </button>
                          )}
                        </label>
                      </div>
                    </div>
                  )
                })
              ) : (
                <div className="col-md-12">No images found on AWS</div>
              )}
            </div>
            <div className="row mt-2">
              <div className="col-md-12">
                <h4>Video</h4>
              </div>
            </div>
            <div className="row upload-media-row">
              {videos.length > 0 ? (
                videos.map((video, videoIndex) => {
                  if (SearchString !== '' && video.toLowerCase().indexOf(SearchString) < 0)
                    return null
                  const fileName = new URL(video).pathname.split('/').pop()
                  return (
                    <div
                      className="col-md-4 col-lg-3 col-xl-2 upload-media-col"
                      key={`video-${video}`}
                    >
                      <div className="upload-media-repeat">
                        <input
                          type="checkbox"
                          className="upload-media-checkbox"
                          id={'video_' + videoIndex}
                          name="video"
                          onChange={handleInputChanges('video')}
                          value={video}
                          checked={SelectedMediaFiles.video === video}
                        />
                        <label htmlFor={'video_' + videoIndex}>
                          <div className="col-12">
                            <video
                              width={150}
                              height={150}
                              autoPlay
                            >
                              <source
                                src={video}
                                type="video/mp4"
                              ></source>
                            </video>
                            <p>{fileName}</p>
                          </div>
                        </label>
                      </div>
                    </div>
                  )
                })
              ) : (
                <div className="col-md-12">No Videos found on AWS</div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            disabled={loading}
            onClick={(e) => submitMedia(e)}
          >
            Submit
          </Button>
          <Button
            variant="primary"
            onClick={(e) => closeModal(e)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={IsShowOptionModal}
        onHide={(e) => setIsShowOptionModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Apply Image To?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <input
                  type="radio"
                  name="apply_type"
                  value="current-option"
                  id="current-option"
                  onChange={(e) => onApplyTypeChange(e)}
                />
                <label htmlFor="current-option">&nbsp;Current Option Only</label>
              </div>
              <div className="col-md-6">
                <input
                  type="radio"
                  name="apply_type"
                  value="specific"
                  id="apply-specific"
                  onChange={(e) => onApplyTypeChange(e)}
                />
                <label htmlFor="apply-specific">&nbsp;By Specific Option</label>
              </div>
            </div>
            {ImageApplyType === 'specific' && (
              <div className="row">
                <div className="col-md-12">
                  <label>Select Option:</label>
                  <select
                    className="form-control"
                    name="attribute_option"
                    onChange={handleInputChanges('attribute_option')}
                    value={ImageOptionId}
                  >
                    <option value="">Select</option>
                    {CurrentImageVariant.map((item) => {
                      return (
                        <option
                          value={item.option_id}
                          key={item.option_id}
                        >
                          {item.attribute_name + ' - ' + item.option_value}
                        </option>
                      )
                    })}
                  </select>
                  {validator.message('Option', ImageOptionId, 'required', {
                    className: 'error'
                  })}
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            disabled={loading}
            onClick={(e) => applyImages(e)}
          >
            Apply
          </Button>
          <Button
            variant="primary"
            onClick={(e) => setIsShowOptionModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
export default UploadMedia
